import { EmptyCell, Icon, Status, Tooltip, Typography } from 'shared/ui'
import type { IColumn } from 'shared/ui/TableNew'
import { type RowSource } from 'entities/Analytics/model/Table/RowSource'
import { getSourceStatusConfig } from './sourcesStatusConfig'
import styles from './styles.module.scss'

const getTypeTooltip = (type: string): string | undefined => {
  switch (type?.toLowerCase()) {
    case 'calls forwarded':
    case 'calls ai calling agent':
      return 'Already counted within Calls Inbound — not added separately to Total calls'
    case 'calls transcript':
      return 'Already counted within Calls Inbound or Calls Outbound — not added separately to Total calls'
    default:
      return undefined
  }
}

export const getColumns = (): IColumn<RowSource>[] => [
  {
    isSortable: true,
    field: 'source_name',
    name: 'Name',
    width: '31.2%',
    renderRowCell: (row) => {
      if (!row.name) return <EmptyCell />

      return (
        <Typography variant='body-md-regular' ellipsis ariaLabel='SourceName'>
          {row.name}
        </Typography>
      )
    },
  },
  {
    isSortable: true,
    field: 'source_group',
    name: 'Type',
    width: '17.2%',
    renderRowCell: (row) => {
      const tooltipLabel = getTypeTooltip(row.type)

      return (
        <div className={styles.typeCell}>
          <Typography variant='body-md-regular' ellipsis ariaLabel='SourceType'>
            {row.type}
          </Typography>
          {tooltipLabel && (
            <Tooltip placement='top' breakWord label={tooltipLabel}>
              <Icon icon='question' fontSize={14} color={'var(--content-neutral-primary)'} />
            </Tooltip>
          )}
        </div>
      )
    },
  },
  {
    isSortable: true,
    field: 'status',
    name: 'Status',
    width: '17.2%',
    renderRowCell: (row) => {
      return <Status {...getSourceStatusConfig(row.type, row.status)} ariaLabel='SourceStatus' />
    },
  },
  {
    isSortable: true,
    field: 'count_records',
    name: 'Messages/Calls',
    width: '17.2%',
    renderRowCell: (row) => (
      <Typography variant='body-md-regular' ariaLabel='SourceMessages'>
        {row.messages?.toLocaleString() ?? '0'}
      </Typography>
    ),
  },
  {
    isSortable: true,
    field: 'spent_credits',
    name: 'Credits',
    width: '17.2%',
    renderRowCell: (row) => (
      <Typography variant='body-md-regular' ariaLabel='SourceCredits'>
        {row.credits?.toLocaleString() ?? '0'}
      </Typography>
    ),
  },
]
